// extracted by mini-css-extract-plugin
export default {"warning":"x6kAM1"};